"use strict"
import { getRequest, postRequest } from "@/services/RequestService";

export const getNewsletter = async () => {
  const base_route = `newsletters`;
  const response = await getRequest(base_route);
  return response;
}

export const viewNewsletter = async (id) => {
  const base_route = `newsletters/${id}/view`;
  const response = await getRequest(base_route);
  return response;
}

export const storeNewsletter = async (request) => {
  const base_route = `newsletters`;
  const response = await postRequest(base_route, request);
  return response;
}

export const updateNewsletter = async (request, id) => {
  const base_route = `newsletters/${id}/update`;
  const response = await postRequest(base_route, request);
  return response;
}

export const changeNewsletterStatus = async (request, id, type) => {
  const status = type == 1 ? 'activate' : 'deactivate';
  const base_route = `newsletters/${id}/${status}`;
  const response = await postRequest(base_route, request);
  return response;
}

export const updateNewsletterArrangement = async (request) => {
  const base_route = `newsletters/arrangements`;
  const response = await postRequest(base_route, request);
  return response;
}
